import mainCaller from './mainCaller';
var qs = require('qs');

export const getAllBanners = async (query, token) => {
  return await mainCaller(`admin/api/v1/banners?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const getBannerById = async (id, token) => {
  return await mainCaller(`admin/api/v1/banners/${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const deleteBannerById = async (id, token) => {
  return await mainCaller(`admin/api/v1/banners/${id}`, 'DELETE', null, {
    Authorization: 'Bearer ' + token,
  });
};

export const createBanner = async (data, token) => {
  return await mainCaller('admin/api/v1/banners', 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
};

export const updateBanner = async (id, data, token) => {
  return await mainCaller(`admin/api/v1/banners/${id}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
};

export const getAllVODs = async (query, token) => {
  return await mainCaller(`admin/api/v1/course/VODs?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const getVODById = async (id, token) => {
  return await mainCaller(`admin/api/v1/course/VODs/${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const createVOD = async (data, token) => {
  return await mainCaller('admin/api/v1/course/VODs', 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
};

export const updateVOD = async (id, data, token) => {
  return await mainCaller(`admin/api/v1/course/VODs/${id}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
};

export const deleteVODById = async (id, token) => {
  return await mainCaller(`admin/api/v1/course/VODs/${id}`, 'DELETE', null, {
    Authorization: 'Bearer ' + token,
  });
};

export const getMemberSelection = async (id, token) => {
  return await mainCaller(`admin/api/v1/search-options/members?branchId=${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const getLockers = async (id, token) => {
  return await mainCaller(`admin/api/v2/branches/${id}/lockers`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const getLockerArea = async (id, token) => {
  return await mainCaller(`admin/api/v2/branches/${id}/locker-areas`, `GET`, null, {
    Authorization: `Bearer ${token}`,
  });
};

export const createLockerArea = async (id, token, data) => {
  return await mainCaller(`admin/api/v2/branches/${id}/locker-areas`, 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });
};

export const updateLockerArea = async (id, areaId, token, data) => {
  return await mainCaller(`admin/api/v2/branches/${id}/locker-areas/${areaId}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });
};

export const createLocker = async (id, token, count) => {
  return await mainCaller(`admin/api/v1/branches/${id}/lockers?count=${count}`, 'POST', null, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });
};

export const updateLocker = async (id, token, data) => {
  return await mainCaller(`admin/api/v2/branches/lockers/${id}`, 'put', data, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });
};

export const updateLockerReset = async (id, token) => {
  return await mainCaller(`admin/api/v2/branches/reset/lockers/${id}`, 'put', null, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });
};

export const deleteLocker = async (id, token) => {
  return await mainCaller(`admin/api/v2/branches/lockers/${id}`, 'delete', null, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });
};

// 라커 자리 사용 이력 (#165) — 최신순
export const getLockerSpotLogs = async (lockerId, token) => {
  return await mainCaller(`admin/api/v2/branches/lockers/${lockerId}/logs`, 'GET', null, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });
};

export const moveLocker = async (sourceLockerId, targetLockerId, token) => {
  return await mainCaller(
    `admin/api/v2/branches/lockers/move`,
    'put',
    {
      sourceLockerId,
      targetLockerId,
    },
    {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  );
};

export const deleteLockerArea = async (branchId, lockerAreaId, token) => {
  return await mainCaller(`admin/api/v2/branches/${branchId}/locker-areas/${lockerAreaId}`, 'delete', null, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });
};

export const createPass = async (data, token) => {
  return await mainCaller('admin/api/v1/course/passes', 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
};

export const updatePass = async (id, data, token) => {
  return await mainCaller(`admin/api/v1/course/passes/${id}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
};

export const getAllPass = async (query, token) => {
  return await mainCaller(`admin/api/v1/course/passes?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 이용권 셀렉트용 슬림 응답. 일반 패스 + classType=PASS 체험권을 통합 반환.
// 목록 표시용 정가/판매가(regularPrice, finalPrice)만 포함하고, 폼에 채울 금액은
// 선택 후 sourceType 으로 상세 API 분기해서 가져온다.
//   sourceType === 'COURSE_PASS'  → getPassById(id)
//   sourceType === 'TRIAL_TICKET' → getTrialById(id)
export const getCoursePassSelectionOptions = async (token, branchId, sportType) => {
  const params = new URLSearchParams({ branchId });
  if (sportType) params.append('sportType', sportType);
  return await mainCaller(
    `admin/api/v1/search-options/course-passes?${params.toString()}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  );
};

export const getPassById = async (id, token) => {
  return await mainCaller(`admin/api/v1/course/passes/${id}`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

export const deletePassById = async (id, token) => {
  return await mainCaller(`admin/api/v1/course/passes/${id}`, 'DELETE', null, {
    Authorization: 'Bearer ' + token,
  });
};

export const changeStatusPass = async (status, id, token) => {
  return await mainCaller(`admin/api/v1/course/passes/${id}?saleStatus=${status}`, 'PATCH', null, {
    Authorization: 'Bearer ' + token,
  });
};

// Trial (일일권) API
export const createTrial = async (data, token) => {
  return await mainCaller('admin/api/v1/trial-tickets', 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
};

// Trial Ticket (일일권) API - 새 API
export const createTrialTicket = async (data, token) => {
  return await mainCaller('admin/api/v1/trial-tickets', 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
};

export const updateTrialTicket = async (id, data, token) => {
  return await mainCaller(`admin/api/v1/trial-tickets/${id}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
};

export const updateTrial = async (id, data, token) => {
  return await mainCaller(`admin/api/v1/trial-tickets/${id}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
};

export const getAllTrial = async (query, token) => {
  return await mainCaller(`admin/api/v1/trial-tickets?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const getTrialById = async (id, token) => {
  return await mainCaller(`admin/api/v1/trial-tickets/${id}`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

export const deleteTrialById = async (id, token) => {
  return await mainCaller(`admin/api/v1/trial-tickets/${id}`, 'DELETE', null, {
    Authorization: 'Bearer ' + token,
  });
};

export const changeStatusTrial = async (status, id, token) => {
  return await mainCaller(`admin/api/v1/trial-tickets/${id}?saleStatus=${status}`, 'PATCH', null, {
    Authorization: 'Bearer ' + token,
  });
};

// 회원 일일권 기간/횟수 변경
export const updateMemberTrialTicketData = async (memberId, memberTrialTicketId, data, token) => {
  return await mainCaller(`admin/api/v1/members/${memberId}/trial-tickets/${memberTrialTicketId}`, 'PUT', data, {
    Authorization: 'Bearer ' + token,
  });
};

export const createTicket = async (data, token) => {
  return await mainCaller('admin/api/v1/course/tickets', 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
};

export const updateTicket = async (id, data, token) => {
  return await mainCaller(`admin/api/v1/course/tickets/${id}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
};

// 회원 수강권 자동 차감 설정 변경 (count null이면 해제)
export const updateMemberTicketAutoDeduction = async (id, memberCourseTicketId, data, token) => {
  return await mainCaller(`admin/api/v1/members/${id}/tickets/${memberCourseTicketId}/auto-deduction`, 'PUT', data, {
    Authorization: 'Bearer ' + token,
  });
};

// 회원권 1건의 이용지점 수동 조정(다지점 공유 상품의 회원별 예외). data = { branchIds: [..] }
export const updateMemberTicketUseBranches = async (id, memberCourseTicketId, data, token) => {
  return await mainCaller(`admin/api/v1/members/${id}/tickets/${memberCourseTicketId}/use-branches`, 'PUT', data, {
    Authorization: 'Bearer ' + token,
  });
};

export const updateMemberPassUseBranches = async (id, memberCoursePassId, data, token) => {
  return await mainCaller(`admin/api/v1/members/${id}/passes/${memberCoursePassId}/use-branches`, 'PUT', data, {
    Authorization: 'Bearer ' + token,
  });
};

export const updateMemberTrialUseBranches = async (id, memberTrialTicketId, data, token) => {
  return await mainCaller(`admin/api/v1/members/${id}/trial-tickets/${memberTrialTicketId}/use-branches`, 'PUT', data, {
    Authorization: 'Bearer ' + token,
  });
};

// 수강권 회원 간 공유(#154) — 소유자 회원 기준 경로.
export const getTicketShares = async (id, memberCourseTicketId, token) => {
  return await mainCaller(`admin/api/v1/members/${id}/tickets/${memberCourseTicketId}/shares`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

export const searchTicketShareCandidates = async (id, memberCourseTicketId, keyword, token) => {
  // 지점은 서버가 X-Branch-Id(mainCaller)로 판정한다.
  const query = qs.stringify({ keyword });
  return await mainCaller(
    `admin/api/v1/members/${id}/tickets/${memberCourseTicketId}/share-candidates?${query}`,
    'GET',
    null,
    { Authorization: 'Bearer ' + token },
  );
};

export const updateTicketShares = async (id, memberCourseTicketId, data, token) => {
  return await mainCaller(`admin/api/v1/members/${id}/tickets/${memberCourseTicketId}/shares`, 'PUT', data, {
    Authorization: 'Bearer ' + token,
  });
};

export const updateTicketData = async (id, memberCourseTicketId, data, token) => {
  return await mainCaller(`admin/api/v1/members/${id}/tickets/${memberCourseTicketId}`, 'PUT', data, {
    Authorization: 'Bearer ' + token,
  });
};

export const updatePassData = async (id, memberCoursePassId, data, token) => {
  return await mainCaller(`admin/api/v1/members/${id}/passes/${memberCoursePassId}`, 'PUT', data, {
    Authorization: 'Bearer ' + token,
  });
};

export const updateTicketFreezyData = async (data, token) => {
  return await mainCaller('admin/freezeByTicketIdAndUserId', 'POST', data, {
    Authorization: 'Bearer ' + token,
  });
};

export const searchTickets = async (token, id) => {
  return await mainCaller(`admin/api/v1/search-options/course-tickets?branchId=${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const searchTicketTutor = async (token, id) => {
  return await mainCaller(`admin/api/v1/search-options/course-trainers?courseTicketId=${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const getAllTickets = async (query, token) => {
  return await mainCaller(`admin/api/v1/course/tickets?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const getTicketsByClassType = async (types, token) => {
  return await mainCaller('admin/findTicketByType', 'POST', types, {
    Authorization: 'Bearer ' + token,
  });
};

export const getTicketById = async (id, token) => {
  return await mainCaller(`admin/api/v1/course/tickets/${id}`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

export const changeStatus = async (status, id, token) => {
  return await mainCaller(`admin/api/v1/course/tickets/${id}?saleStatus=${status}`, 'PATCH', null, {
    Authorization: 'Bearer ' + token,
  });
};

export const getTicketsByType = async (data, token) => {
  return await mainCaller(`admin/api/v1/search-options/course-tickets?${data}`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

export const getTicketsByClassTime = async (id, token) => {
  return await mainCaller(`admin/api/v1/course/classes/times/${id}/members`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};
// 폐강(최소 인원 미달)으로 예약이 취소된 회원 — 참석관리 창 연락용
export const getClosedCanceledMembersByClassTime = async (id, token) => {
  return await mainCaller(`admin/api/v1/course/classes/times/${id}/members/closed-canceled`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};
// force=true 는 상담이 낀 일정 겹침을 사용자가 확인한 뒤 다시 보낼 때만 쓴다(withOverlapConfirm)
export const addMembersToCourse = async (id, body, token, force = false) => {
  return await mainCaller(`admin/api/v1/course/classes/times/${id}/members${force ? '?force=true' : ''}`, 'POST', body, {
    Authorization: 'Bearer ' + token,
  });
};

// 회원이 이 수업에 사용 가능한 유효 수강권 목록 (예약 차감 수강권 선택 모달용)
export const getMemberAvailableTickets = async (courseClassTimeId, memberId, token) => {
  return await mainCaller(
    `admin/api/v1/course/classes/times/${courseClassTimeId}/members/${memberId}/available-tickets`,
    'GET',
    null,
    { Authorization: 'Bearer ' + token },
  );
};

export const deleteTicketById = async (id, token) => {
  return await mainCaller(`admin/api/v1/course/tickets/${id}`, 'DELETE', null, {
    Authorization: 'Bearer ' + token,
  });
};

export const attendMembersToClassroom = async (id, body, token) => {
  return await mainCaller(
    `admin/api/v1/course/classes/times/${id}/members/attend?${qs.stringify(body)}`,
    'POST',
    body,
    {
      Authorization: 'Bearer ' + token,
    },
  );
};

export const attendMembersToClassroomMiss = async (id, body, token) => {
  return await mainCaller(`admin/api/v1/course/classes/times/${id}/members/miss?${qs.stringify(body)}`, 'POST', body, {
    Authorization: 'Bearer ' + token,
  });
};

export const attendMembersToClassroomDelete = async (id, body, token) => {
  return await mainCaller(`admin/api/v1/course/classes/times/${id}/members?${qs.stringify(body)}`, 'DELETE', body, {
    Authorization: 'Bearer ' + token,
  });
};

// 이용권 중지권 횟수 변경
export const passChangeStopCount = async (memberCoursePassId, count, token) => {
  const query = count === null ? '' : `?stopCount=${count}`;
  return await mainCaller(
    `admin/api/v1/course/passes/member/${memberCoursePassId}/stop-count${query}`,
    'PATCH',
    null,
    {
      Authorization: 'Bearer ' + token,
    },
  );
};

// 이용권 중지권 일수 변경 (null = 무제한)
export const passChangeStopPeriod = async (memberCoursePassId, period, token) => {
  const query = period === null ? '' : `?stopPeriod=${period}`;
  return await mainCaller(
    `admin/api/v1/course/passes/member/${memberCoursePassId}/stop-period${query}`,
    'PATCH',
    null,
    {
      Authorization: 'Bearer ' + token,
    },
  );
};

// 수강권 중지권 횟수 변경 (null = 무제한)
export const ticketChangeStopCount = async (memberCoursePassId, count, token) => {
  const query = count === null ? '' : `?stopCount=${count}`;
  return await mainCaller(
    `admin/api/v1/course/tickets/member/${memberCoursePassId}/stop-count${query}`,
    'PATCH',
    null,
    {
      Authorization: 'Bearer ' + token,
    },
  );
};

// 수강권 중지권 일수 변경 (null = 무제한)
export const ticketChangeStopPeriod = async (memberCoursePassId, period, token) => {
  const query = period === null ? '' : `?stopPeriod=${period}`;
  return await mainCaller(
    `admin/api/v1/course/tickets/member/${memberCoursePassId}/stop-period${query}`,
    'PATCH',
    null,
    {
      Authorization: 'Bearer ' + token,
    },
  );
};

// 회원의 라커 이용권 목록 조회 (연장용)
export const getMemberLockerTickets = async (branchId, memberId, token) => {
  return await mainCaller(`admin/api/v2/branches/${branchId}/members/${memberId}/my-locker`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

// 지점 라커 상품 목록 — 상품 단위로 회원을 추리는 필터 셀렉트에 쓴다.
export const getLockerPassSelectionOptions = async (token, branchId) => {
  return await mainCaller(
    `admin/api/v1/search-options/locker-passes?branchId=${branchId}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  );
};

export const getAvailableClasses = async (ticketId, branchId, token) => {
  return await mainCaller(
    `admin/api/v1/course/tickets/${ticketId}/available-classes?branchId=${branchId}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  );
};

export const assignTicketToClasses = async (ticketId, branchId, courseClassIds, token) => {
  return await mainCaller(
    `admin/api/v1/course/tickets/${ticketId}/assign-classes?branchId=${branchId}&courseClassIds=${courseClassIds.join(',')}`,
    'POST',
    null,
    { Authorization: `Bearer ${token}` },
  );
};
